/**
 * A directive for font display options.
 *
 * To implement this directive, follow this example:
 *
 * In your template:
 *
 * <font-display-options
 *    tk-web-project-card-model="controller.tkWebProjectCardModel"
 *    tk-web-project-family-card-model="controller.tkWebProjectFamilyCardModel">
 * </font-display-options>
 *
 * In your Javascript Controller:
 *
 * - tkWebProjectCardModel: The model which contains the details of the web project/kit.
 * - tkWebProjectFamilyCardModel: The model which contains the details of the tkff.
 *
 * @ngInject
 */
function Directive() {
  return {
    restrict: 'E',
    templateUrl: '/angular_templates/directives/font_display_options.html',
    scope: {},
    bindToController: {
      tkWebProjectCardModel: '=',
      tkWebProjectFamilyCardModel: '='
    },
    controller: require('./controller.js'),
    controllerAs: 'fontDisplayOptionsCtrl'
  };
}

module.exports = Directive;
